import React from "react";
import {IJobDefinitionStep} from "../../models/JobDefinitionStep";
import {Badge, Tooltip} from "@mui/material";
import {IJobStepRun} from "../../models/JobStepRun";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface IJobRunStatus {
	jobSteps: IJobDefinitionStep[];
	jobRunSteps: IJobStepRun[];
}

export const JobRunStatus: React.FC<IJobRunStatus> = (props) => {
	return (
		<>
			<div style={{width: "100%", display: "flex"}}>
				{props.jobSteps?.sort((a,b) => a.order < b.order? -1: 1).map((step: IJobDefinitionStep) => {
					//const jobRunStep = props.jobRunSteps[index];
					const jobRunStep = props.jobRunSteps.find(
						(x) => x.jobStep && x.jobStep.id === step.id
					);
					return <Tooltip title={step.description}>
						<div style={{width: "100px"}}>
							
							{jobRunStep &&
								<>
									{jobRunStep.failed > 0 &&
										<Badge showZero={false} color="error" badgeContent={step.order}
											max={1000000}>
											<ErrorOutlineIcon/>
										</Badge>}
									{jobRunStep.succeeded > 0 &&
										<Badge showZero={false} color="success" badgeContent={jobRunStep.succeeded}
											max={1000000}>
											< CheckCircleOutlineIcon/>
										</Badge>
									}
								</>
								
							}
						</div>
					</Tooltip>;
				})}
			</div>
		</>
	);
	
};

